import React,{Component} from 'react';
import Button from '@material-ui/core/Button';
import {history} from '../../../shared/configure-store';
import {connect} from 'react-redux';
import {RootActions} from '../../../shared/root-action';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import SimpleReactValidator from 'simple-react-validator';
import Logo from '../../../images/logo-black.png';
import Copyright from '../../presentational/copyright';
import {toast, ToastContainer} from 'react-toastify';
import {bindActionCreators} from 'redux';
import QRCode from 'qrcode.react';
import Api from '../../../libraries/api';
import ReactToPrint from 'react-to-print';
import _ from "lodash";
import language from "../../../libraries/label-lang";
import AuthHelper from "../../../libraries/auth-helper";

require('dotenv').config();

class ReservationPrint extends Component {
    constructor(props) {

        super(props);

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );

        this.state = {
            loading: false,
            loadingButton: false,

            email: '',
            warehouseId: '',
            warehouse: '',

            errors: [],
            labels: [],
            warehouseList: [],
        };
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Berhasil';

        this.setState({
            loading: true,
        });

        Api.get('/warehouses').then(resp => {
            if (resp.data) {

                this.setState({
                    warehouseList: resp.data,
                    loading: false,
                })

            }
        }).catch(err => {
            this.showMessage(false, err.message);
        });

    }

    __fetchPrint = () => {
        Api.get('/locker/print?warehouseId='+this.state.warehouseId).then(resp => {
            if (resp.data) {
                let dataLababels = [];
                let item = [];
                if (resp.data.length > 0) {

                    _.forEach(resp.data, function (v, i) {
                        let row = i + 1;

                        let mod = row % 5;
                        if (mod === 1) {
                            item = [];
                        }

                        item.push(v);
                        if (mod === 1) {
                            dataLababels.push(item);
                        }
                    });


                    this.setState({
                        labels: dataLababels,
                        loading: false,
                    })

                }
            }
        }).catch(err => {
            console.log(err);

            this.setState({
                    loading: true,
                }
            );

        });
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleGo  = (link) => {

        history.push(link);
    };

    handleChange (e, prop){
        let index = e.nativeEvent.target.innerText;

        this.setState({

            [prop]: e.target.value,
            warehouse: index,

        }, () => {

            this.__fetchPrint();
        });
    };

    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (
            <main className='main'>
                <section className='my-auto'>
                    <div className='container text-center'>
                        <div className='row'>
                            <div className='col-md-10 col-lg-8 text-center'>
                                <form name='add' id='addProduct' className='row' noValidate>
                                    <div className='col-12 mb-2 text-left'>
                                        <div className='form-group'>
                                            <TextField
                                                select
                                                id='warehouseId'
                                                name='warehouseId'
                                                label={text.label_warehouse}
                                                onChange={(e) => this.handleChange(e, 'warehouseId')}
                                                value={this.state.warehouseId}
                                                fullWidth
                                            >
                                                {this.state.warehouseList.map((option, idx) => (
                                                    <MenuItem key={idx} value={option.id}>
                                                        {option.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                            {this.validator.message('warehouseId', this.state.warehouseId, 'required')}
                                            <div className='text-danger'>{this.state.errors.warehouseId}</div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className='row'>
                            {this.state.loading ? (
                                <div className='col-12'>
                                    <i className='fa fa-spinner fa-spin'>&nbsp; </i>
                                </div>
                            ) : (
                                this.state.labels.length === 0 ? (
                                    <div className='col-12'>
                                        <p>{text.label_no}</p>
                                    </div>
                                ) : (
                                    <PrintLabels data={this.state.labels } name={this.state.warehouse} ref={el => (this.componentRef = el)} />
                                )
                            )}
                        </div>

                        <div className='mt-4 button-small'>
                            <ReactToPrint
                                trigger={() =>  <Button
                                    variant='contained'
                                    color='primary'
                                    className='mr-3'
                                    disabled={this.state.labels.length === 0}
                                >Print</Button>}
                                content={() => this.componentRef}
                            />
                           {/* <Button
                                variant='contained'
                                className='btn-link mr-3'
                                disabled={this.state.labels.length === 0}
                                onClick={() => this.handleGo('/reservation-note/'+this.props.match.params.id)}
                            >
                                {text.button_next}
                            </Button>*/}
                        </div>
                    </div>
                </section>
                <footer>
                    <p className='text-center absolute-bottom'><Copyright /></p>
                </footer>
                <ToastContainer autoClose={false} />
            </main>
        );
    }
}

class PrintLabels extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            email: '',
            name: this.props.name,
            labels: this.props.data,
        };
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Berhasil';
        Api.get('/warehouses').then(resp => {
            if (resp.data) {

                this.setState({
                    warehouseList: resp.data,
                    loading: false,
                })

            }
        }).catch(err => {
            this.showMessage(false, err.message);
        });


    }

    render() {

        return (
            <table width="100%">
                <thead>
                    <tr>
                        <th colSpan={5}>{this.state.name}</th>
                    </tr>
                </thead>
                <tbody>
                {
                    this.state.labels.length > 0 &&
                    this.state.labels.map((row, idx) => {
                        return (
                            <tr key={idx}>
                                {
                                    row.map(item => {
                                        return (
                                            <td key={item.id} width="20%">
                                                <div className='card card-label locker'>
                                                    <div className='label-content mb-2'>
                                                        <h4 className='mb-0 text-uppercase'>{item.area}</h4>
                                                        <p className='text-uppercase'><strong>{item.lockerName}</strong></p>
                                                        <small className='text-uppercase'><strong>{item.type_rack} - {item.size_rack}</strong></small>
                                                        <p className='text-uppercase'>{item.type_container}</p>
                                                    </div>
                                                    <QRCode
                                                        size={80}
                                                        value={item.id}/>

                                                </div>
                                            </td>
                                        );
                                    })
                                }
                            </tr>
                        );
                    })
                }
                </tbody>
            </table>
        )
    }
}


const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

        toggle_set_lang: state.toggle_set_lang,
    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(ReservationPrint);